import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileWithProgress } from "@/views/drive/modals/uploadModal/types";

interface UploadExistsFilesConfirmationModalProps {
  fileWithProgress: FileWithProgress;
  onAccept: () => void;
  onCancel: () => void;
}

export const UploadConfirmCancel: React.FC<UploadExistsFilesConfirmationModalProps> = ({
  onAccept,
  fileWithProgress,
  onCancel,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const handleClose = () => {
    onCancel();
  };

  const handleConfirm = () => {
    onAccept();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm operation</DialogTitle>
        </DialogHeader>
        <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
          <p className="text-md m-2 text-gray-500">
            Upload of the file <strong>{fileWithProgress.file.name}</strong> is already in progress. Do you want to
            cancel?
          </p>
        </div>
        <div className="mt-4 flex justify-between">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>

          <Button onClick={handleConfirm}>Confirm</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
